import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel, IRecomendacaoOsaExecucaoMatrizModel } from "./../../../../models/plano-acao-model";
import { PlanoAcaoService } from "./../../../../services/plano-acao.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../services/auth.service";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { MatrizConstatacoesService } from "./../../../../services/matriz-constatacao.service";
import { IEnumModel } from "../../../../models/enum.model";
import { IResponsavelWithTipoSelectModel } from "../../../../models/responsaveis.model";
import { PlanoAcaoRecomendacaoComponent } from "../plano-acao-recomendacao/plano-acao-recomendacao.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../../shared/util/angularEditorConfig";

@Component({
  selector: 'app-plano-acao-form-acao',
  templateUrl: './plano-acao-form-acao.component.html',
  styleUrls: ['./plano-acao-form-acao.component.scss']
})

export class PlanoAcaoFormAcaoComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaRecomendacaoPaginator", { static: true })
  tabelaRecomendacaoPaginator: MatPaginator;
  @ViewChild("tabelaRecomendacaoSort", { static: true })
  tabelaRecomendacaoSort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;

  public model = this.createModel();
  public planoStatus: number = 0;
  public readonly textoAposAvaliacao =
    'Ação adicionada após a apreciação do Plano de Ação pelo Auditor, portanto, essa ação não foi avaliada previamente e terá sua efetividade aferida durante a etapa de monitoramento';
  public dataSourceRecomendacao = new MatTableDataSource<IAcaoPlanoAcaoRecomendacaoModel>([]);
  public recomendacaoSelecionada: IRecomendacaoOsaExecucaoMatrizModel = {} as IRecomendacaoOsaExecucaoMatrizModel;
  public responsaveis: IResponsavelWithTipoSelectModel[];

  public tituloModal = "";
  public visualizar = false;
  public alterar = false;
  public id: number = 0;
  public planoAcaoId: number = 0;
  public unidadeGestoraId: number = 0;
  public osaExecucaoId: number = 0;

  public editorConfig: AngularEditorConfig = angularEditorConfig(
    "Digite a descrição",
    "180px",
    "100%"
  );

  public editorMaxLength = 1000;

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public planoAcaoService: PlanoAcaoService,
    public matrizConstatacaoService: MatrizConstatacoesService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<PlanoAcaoFormAcaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.alterar = data?.alterar;
    this.tituloModal = data?.titulo;
    this.planoAcaoId = data?.planoAcaoId;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.osaExecucaoId = data?.osaExecucaoId;
    this.planoStatus = data?.planoStatus;

    if (data?.element) {
      this.model = data?.element;
    }

    //-> plano Avaliado: a nova ação nasce "A ser Realizada"
    if (!data?.element && this.planoStatus === 3) {
      this.model.status = this.statusAserRealizada();
    }
  }

  ngOnInit(): void {
    this.obterResponsaveis(this.unidadeGestoraId);
    if (this.id)
      this.obter(this.id);
  }

  get aposAvaliacao(): boolean {
    return this.planoStatus === 3 || this.model?.adicionadaAposAvaliacao === true;
  }

  private statusAserRealizada(): IEnumModel {
    return { codigo: 6, nome: 'AserRealizada', descricao: 'A ser Realizada' } as IEnumModel;
  }

  private statusCadastrada(): IEnumModel {
    return { codigo: 1, nome: 'Cadastrada', descricao: 'Cadastrada' } as IEnumModel;
  }

  private toast(icon: 'success' | 'warning' | 'error', text: string) {
    Swal.fire({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      icon,
      text,
    });
  }

  public obterResponsaveis(id: any) {

    this.responsaveis = [];

    this.planoAcaoService.obterResponsaveis(id).then((res) => {
      if (res.sucesso) {
        this.responsaveis = res.dados;
      } else {
        this.toast("warning", res.mensagem.descricao);
      }
    })
  }

  private createModel(): IAcaoPlanoAcaoModel {
    return {
      id: 0,
      planoAcaoId: 0,
      planoAcao: {} as IPlanoAcaoModel,
      identificador: 0,
      titulo: '',
      descricao: '',
      responsavelId: '',
      responsavelNome: '',
      prazo: new Date,
      status: { codigo: 1, nome: 'Cadastrada', descricao: 'Cadastrada' } as IEnumModel,
      justificativaAvaliacao: '',
      nivelRelevancia: null,
      comentarioAuditor: '',
      descricaoImplementacao: '',
      dataRealizacao: null,
      descricaoImplementacaoAuditor: '',
      avaliacao: null,
      dataMonitoramento: null,
      responsavelIdMonitoramento: '',
      responsavelNomeMonitoramento: '',
      responsavelCargoMonitoramento: '',
      recomendacoes: [],
      evidencias: [],
      evidenciasAuditor: [],
      adicionadaAposAvaliacao: false
    };
  }

  public obter(id: number) {

    this.planoAcaoService
      .obterAcaoPorId(id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;

          this.model.prazo = new Date(this.model.prazo);

          this.dataSourceRecomendacao.data = this.model?.recomendacoes;
          this.dataSourceRecomendacao.paginator = this.tabelaRecomendacaoPaginator;
          this.dataSourceRecomendacao.sort = this.tabelaRecomendacaoSort;
          this.dataSourceRecomendacao.sortingDataAccessor = this.sortingDataAccessor;

        } else {
          this.toast("warning", res.mensagem.descricao);
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "titulo":
        return item.recomendacao.titulo;
      default:
        return item[property];
    }
  };

  public async exibirModalRecomendacao() {

    try {
      const res = await this.matrizConstatacaoService.obterRecomendacoesMatrizDefinitivaPorOsaExecucao(this.osaExecucaoId);
      if (res.sucesso) {

        const columns: { columnDef: string, header: string }[] = [
          { columnDef: 'id', header: 'Id' },
          { columnDef: 'titulo', header: 'Título' }
        ];

        const modal = this.exibirModal("Selecionar Recomendação", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.recomendacaoSelecionada = data;
          }
        });
      } else {
        this.toast("error", res.mensagem.descricao);
      }
    } catch (err) {
      this.toast("error", err?.mensagem?.descricao);
    }
  }

  public addRecomendacao() {

    if (!this.recomendacaoSelecionada.id) {
      this.toast("warning", "Selecione a Recomendação para incluir!");
      return;
    }

    //-> antes de adicionar a recomendação, verifica se ja existe
    const idx = this.model.recomendacoes?.findIndex(x => x.recomendacaoId === this.recomendacaoSelecionada.id);
    if (idx !== undefined && idx > -1) {
      this.toast("warning", "Recomendação já foi relacionada!");
      return;
    }

    // adiciona na grade
    const novaRecomendacao: IAcaoPlanoAcaoRecomendacaoModel = {
      id: 0,
      acaoId: this.id,
      acao: {} as IAcaoPlanoAcaoModel,
      recomendacaoId: this.recomendacaoSelecionada.id,
      recomendacao: this.recomendacaoSelecionada
    };

    this.model.recomendacoes.push(novaRecomendacao);
    this.dataSourceRecomendacao.data = [...this.model.recomendacoes];
    this.recomendacaoSelecionada = {} as IRecomendacaoOsaExecucaoMatrizModel;
  }

  public excluirRecomendacao(index: number) {

    Swal.fire({
      title: "Excluir Recomendação ?",
      text: "Confirma exclusão da Recomendação?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.recomendacoes?.splice(index, 1);
        this.dataSourceRecomendacao.data = [...this.model.recomendacoes];
      }
    });
  }

  public modalRecomendacao(element?: IAcaoPlanoAcaoRecomendacaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-recomendacao";
    dialogConfig.width = "50vw";
    dialogConfig.height = "45vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Recomendação",
      element
    };

    this.matDialog.open(PlanoAcaoRecomendacaoComponent, dialogConfig);
  }

  public salvar() {

    if (!this.model.titulo) { this.toast("warning", "Título da Ação não informado!"); return; }
    if (!this.model.descricao) { this.toast("warning", "Descrição da Ação não informada!"); return; }
    if (!this.model.responsavelId) { this.toast("warning", "Responsável da Ação não informado!"); return; }
    if (!this.model.prazo) { this.toast("warning", "Prazo de Implementação da Ação não informado!"); return; }
    if (this.model.recomendacoes.length <= 0) { this.toast("warning", "Recomendações não foram vinculadas!"); return; }

    const tratarResposta = (res) => {
      if (res.sucesso) {
        this.dialogRef.close(true);
        this.toast("success", res.mensagem.descricao);
      } else {
        this.toast("warning", res.mensagem.descricao);
      }
    };

    //-> nas inclusões força o status: plano Avaliado = "A ser Realizada"; senão "Cadastrada"
    if (this.id === 0) {
      this.model.status = this.planoStatus === 3 ? this.statusAserRealizada() : this.statusCadastrada();
      this.model.planoAcaoId = this.planoAcaoId;

      this.planoAcaoService.inserirAcao(this.model).then(tratarResposta);
    }
    else {
      this.planoAcaoService.atualizarAcao(this.model).then(tratarResposta);
    }
  }

  public fechar() {
    this.dialogRef.close();
  }

  public cancelar() {
    Swal.fire({
      title: "Cancelar",
      text: "Todas as informações preenchidas serão perdidas. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.dialogRef.close();
      }
    });
  }

  ngAfterViewInit() {

    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 1000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }

  onEditorChange(content: string) {
    if (content.length > this.editorMaxLength) {
      // corta automaticamente para 1000 caracteres
      this.model.descricao = content.substring(0, this.editorMaxLength);
    }
  }

  onEditorKeyDown(event: KeyboardEvent) {
    if (this.model.descricao?.length >= this.editorMaxLength &&
      event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault(); // bloqueia a digitação
    }
  }

}
